import type { ChatSettingsTranslation } from './types';

export const chatSettingsAr: ChatSettingsTranslation = {
  open: 'إعدادات المحادثة',
  openLabel: 'إعدادات المحادثة لـ {{name}}',
  title: 'إعدادات المحادثة لـ {{name}}',
  description:
    'كيف تظهر المحادثة على موقعك وما يمكن للعملاء فعله فيها. تصل التغييرات إلى المواقع خلال دقيقة.',
  saved: 'حُفظت إعدادات المحادثة لـ {{name}}.',
  save: 'حفظ الإعدادات',
  loading: 'جارٍ تحميل إعدادات المحادثة',
  invalidNumber: 'أدخل عددًا صحيحًا من {{min}} إلى {{max}}.',
  languages: { en: 'الإنجليزية', ar: 'العربية', hi: 'الهندية', ur: 'الأردية' },
  layout: {
    legend: 'أين تظهر المحادثة',
    bubble: 'زر عائم',
    bubbleHint: 'زر دائري في الزاوية يفتح المحادثة.',
    panel: 'لوحة جانبية',
    panelHint: 'يفتح الزر المحادثة على طول أحد جانبي الصفحة.',
    inline: 'داخل الصفحة',
    inlineHint: 'تظهر المحادثة في جزء من صفحتك تختاره.',
    fullpage: 'الصفحة كاملة',
    fullpageHint: 'تملأ المحادثة الصفحة، لصفحة مساعدة خاصة بها.',
    side: 'زاوية الزر',
    right: 'أسفل اليمين',
    left: 'أسفل اليسار',
    note: 'على الهواتف، يفتح الزر العائم واللوحة الجانبية المحادثة بملء الشاشة.',
  },
  files: {
    legend: 'الملفات',
    enabled: 'يمكن للعملاء إرسال ملفات',
    enabledHint:
      'يُفحص كل ملف من الفيروسات أولًا. بدون أداة فحص الفيروسات على الخادم، لا تعرض المحادثة إرسال الملفات.',
    types: 'أنواع الملفات',
    png: 'صور PNG',
    jpeg: 'صور JPEG',
    webp: 'صور WebP',
    gif: 'صور GIF',
    pdf: 'مستندات PDF',
    typesRequired: 'اختر نوعًا واحدًا من الملفات على الأقل.',
    maxMegabytes: 'أكبر حجم للملف (ميغابايت)',
    maxMegabytesHint: 'من 1 إلى 10.',
    maxFiles: 'عدد الملفات في رسالة واحدة',
    maxFilesHint: 'من 1 إلى 5.',
  },
  help: {
    legend: 'المساعدة قبل المحادثة',
    search: 'يمكن للعملاء البحث في مقالات المساعدة العامة',
    suggestions: 'أسئلة مقترحة',
    suggestionsHint:
      'حتى 6 أسئلة، في أول شاشة من المحادثة. الإنجليزية مطلوبة؛ وتظهر الإنجليزية مكان أي لغة فارغة.',
    question: 'السؤال {{number}}',
    add: 'أضف سؤالًا',
    remove: 'أزل السؤال {{number}}',
    required: 'اكتب السؤال {{number}} بالإنجليزية.',
  },
  deletion: {
    label: 'يمكن للعملاء حذف رسالة خلال (دقائق)',
    hint: 'من 0 إلى 60. القيمة 0 توقف الحذف.',
  },
  emails: {
    label: 'اعرض على العملاء المسجلين رسائل بريد عن محادثاتهم',
    hint: 'نسخة عند إغلاق المحادثة، وتنبيه عندما ينتظر رد. العملاء يختارون، وفي كل رسالة رابط لإيقافها.',
  },
};
